module.exports = __webpack_public_path__ + "img/nav_12.f2076b86.png";